import { render, staticRenderFns } from "./PhysicianDutyConflict.vue?vue&type=template&id=8b97deb6&scoped=true&"
import script from "./PhysicianDutyConflict.vue?vue&type=script&lang=js&"
export * from "./PhysicianDutyConflict.vue?vue&type=script&lang=js&"
import style0 from "./PhysicianDutyConflict.vue?vue&type=style&index=0&id=8b97deb6&lang=scss&scoped=true&"
import style1 from "./PhysicianDutyConflict.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b97deb6",
  null
  
)

export default component.exports